import axios from 'axios';

// const Conect = axios.create({ baseURL: 'http://192.168.100.5:2857' });
// const Conect = axios.create({ baseURL: 'http://localhost:2857' });
const Conect = axios.create({ baseURL: 'https://sakamottosann.com.br/api2' });

export default Conect;